import {
  type NotificationDecision,
  shouldNotify,
} from '../contracts/chat-notifications.js';
import { THREAD_CHANNEL_TYPES } from '../contracts/chat-permissions.js';
import type { APIMessage } from '../contracts/chat-types.js';
import { MessageFlags } from '../contracts/chat-types.js';
import { type ChatState, DMS_SETTINGS_KEY } from '../stores/state.js';

/**
 * Notifica esta mensagem? A regra (nível do canal, da categoria e do
 * servidor, silêncio, @everyone, horário de silêncio, "não perturbe") está
 * no contrato (`shouldNotify`); aqui só se junta o que a store sabe.
 */
export function notificationFor(
  state: ChatState,
  message: APIMessage,
  now: Date = new Date(),
): NotificationDecision {
  const me = state.me?.id ?? '';
  const channel = state.channels[message.channel_id];
  const guildId = channel?.guild_id ?? message.guild_id ?? null;
  const parentIds: string[] = [];
  if (channel?.parent_id) {
    parentIds.push(channel.parent_id);
    const parent = state.channels[channel.parent_id];
    if (THREAD_CHANNEL_TYPES.has(channel.type) && parent?.parent_id) {
      parentIds.push(parent.parent_id);
    }
  }
  const myRoles = guildId ? (state.members[guildId]?.[me]?.roles ?? []) : [];
  return shouldNotify(
    {
      authorId: message.webhook_id ? message.webhook_id : message.author.id,
      guildId,
      channelId: message.channel_id,
      parentIds,
      mentionsUser: message.mentions.some((user) => user.id === me),
      mentionsRole: message.mention_roles.some((role) =>
        myRoles.includes(role),
      ),
      mentionsEveryone: message.mention_everyone,
      silent: (message.flags & MessageFlags.SUPPRESS_NOTIFICATIONS) !== 0,
    },
    {
      userId: me,
      status: state.userSettings?.status,
      quietHours: state.userSettings?.quiet_hours ?? null,
      guildDefault: guildId
        ? ((state.guilds[guildId]?.default_message_notifications ?? 1) as 0 | 1)
        : undefined,
      settings: state.guildSettings[guildId ?? DMS_SETTINGS_KEY] ?? null,
      now,
    },
  );
}
